<template>
  <v-dialog :value="value" @input="$emit('input', $event)" fullscreen transition="dialog-bottom-transition">
    <v-card tile class="d-flex flex-column" style="height: 100vh; background: #323639;">
      <v-sheet dark color="#0A7EA5" class="d-flex align-center px-4" style="flex: 0 0 48px;">
        <span class="text-subtitle-1 text-truncate">{{ filename }}</span>
        <v-spacer></v-spacer>

        <v-btn icon :disabled="zoomLevel <= 25" @click="setZoom(-25)">
          <v-icon>mdi-magnify-minus-outline</v-icon>
        </v-btn>
        <span class="text-body-2 mx-1" style="min-width: 42px; text-align: center;">{{ zoomLevel }}%</span>
        <v-btn icon :disabled="zoomLevel >= 200" @click="setZoom(25)">
          <v-icon>mdi-magnify-plus-outline</v-icon>
        </v-btn>
        <v-btn icon @click="resetZoom">
          <v-icon>mdi-fit-to-page-outline</v-icon>
        </v-btn>

        <v-divider vertical dark class="mx-2 my-3"></v-divider>

        <v-btn icon @click="printPDF"><v-icon>mdi-printer</v-icon></v-btn>
        <v-btn icon @click="downloadPDF"><v-icon>mdi-download</v-icon></v-btn>
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-sheet>

      <iframe ref="pdfFrame" v-if="pdfUrl" :key="zoomLevel" :src="pdfUrl + '#toolbar=0&navpanes=0&zoom=' + zoomLevel"
        style="flex: 1 1 auto; width: 100%; border: 0; display: block;"></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PdfPreviewDialog",
  props: {
    value: { type: Boolean, default: false },
    blob: { type: Blob, default: null },
    filename: { type: String, default: "document.pdf" },
    zoom: { type: [String, Number], default: 75 },
  },
  data() {
    return {
      pdfUrl: "",
      zoomLevel: Number(this.zoom) || 75,
    };
  },
  watch: {
    blob: {
      immediate: true,
      handler(val) {
        this.revoke();
        if (val) this.pdfUrl = URL.createObjectURL(val);
      },
    },
    value(val) {
      if (val) this.zoomLevel = Number(this.zoom) || 75;
      else this.revoke();
    },
  },
  beforeDestroy() {
    this.revoke();
  },
  methods: {
    revoke() {
      if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
      this.pdfUrl = "";
    },
    setZoom(step) {
      this.zoomLevel = Math.min(200, Math.max(25, this.zoomLevel + step));
    },
    resetZoom() {
      this.zoomLevel = Number(this.zoom) || 75;
    },
    downloadPDF() {
      if (!this.blob) return;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(this.blob);
      a.download = this.filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
        a.remove();
      }, 1000);
    },
    printPDF() {
      const f = this.$refs.pdfFrame;
      if (!f) return;
      f.contentWindow.focus();
      f.contentWindow.print();
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>